import api from "@/lib/api";
import type {
  StatsParams,
  ApiActiveUserStat,
  ApiKpiStat,
  ApiKpiStatParams,
  ApiDilemmasPerTopicStat,
  ApiPublishedDilemmasStat,
  PublishedDilemmasStatParams,
  ActiveUsersStatParams,
  ExportExcelParams,
} from "../types";

const STATS_ENDPOINTS = {
  ACTIVE_USERS: "/stats/users/",
  DILEMMAS_PER_TOPIC: "/stats/dilemmas-per-topic/",
  EXPORT_EXCEL: "/stats/export-excel/",
  KPIS: "/stats/kpis/",
  PUBLISHED_DILEMMAS: "/stats/published-dilemmas/",
};

export class StatsHttpRepository {
  async fetchActiveUsers(
    params?: ActiveUsersStatParams,
  ): Promise<ApiActiveUserStat[]> {
    const result = await api.get(STATS_ENDPOINTS.ACTIVE_USERS, { params });
    return result.data;
  }
  async fetchDilemmasPerTopic(
    params?: StatsParams,
  ): Promise<ApiDilemmasPerTopicStat[]> {
    const result = await api.get(STATS_ENDPOINTS.DILEMMAS_PER_TOPIC, {
      params,
    });
    return result.data;
  }
  async fetchKpis(params?: ApiKpiStatParams): Promise<ApiKpiStat> {
    const result = await api.get(STATS_ENDPOINTS.KPIS, { params });
    return result.data;
  }
  async fetchPublishedDilemmas(
    params?: PublishedDilemmasStatParams,
  ): Promise<ApiPublishedDilemmasStat[]> {
    const result = await api.get(STATS_ENDPOINTS.PUBLISHED_DILEMMAS, {
      params,
    });
    return result.data;
  }
  async exportExcel(params?: ExportExcelParams): Promise<Blob> {
    const result = await api.get(STATS_ENDPOINTS.EXPORT_EXCEL, {
      params,
      responseType: "blob",
    });
    return result.data;
  }
}
